export const isBlockingPopupActive = (): boolean => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;

  const bodyStyle = window.getComputedStyle(document.body);
  const bodyOverflowY = bodyStyle.overflowY;
  const hasDatasetScrollLock =
    document.body.dataset['ScrollLock'] !== undefined || document.body.dataset['iOSScrollLock'] !== undefined;

  const hasBlockingOverflowValue = (overflowValue: string): boolean => {
    const tokens = overflowValue.toLowerCase().split(/\s+/).filter(Boolean);

    return tokens.includes('hidden') || tokens.includes('clip');
  };

  return bodyStyle.position === 'fixed' || hasBlockingOverflowValue(bodyOverflowY) || hasDatasetScrollLock;
};

export const waitForBlockingPopupInWindow = (
  windowMs: number,
  isBlockingPopupFn: () => boolean = isBlockingPopupActive
): Promise<boolean> => {
  if (isBlockingPopupFn()) return Promise.resolve(true);
  if (typeof MutationObserver === 'undefined') return Promise.resolve(isBlockingPopupFn());

  return new Promise(resolve => {
    let isResolved = false;
    let timeoutId = 0;

    const finish = (isActive: boolean) => {
      if (isResolved) return;
      isResolved = true;
      observer.disconnect();
      window.clearTimeout(timeoutId);
      resolve(isActive);
    };

    const observer = new MutationObserver(() => {
      if (isBlockingPopupFn()) {
        finish(true);
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style', 'class', 'data-scroll-lock', 'data-i-o-s-scroll-lock'],
    });

    timeoutId = window.setTimeout(() => finish(isBlockingPopupFn()), windowMs);
  });
};
